// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"57":"0b045f02","264":"a002cfb3"}[chunkId] + ".css";
};